import { Check, Clear } from "@mui/icons-material";
import { ReactNode } from "react";
import {
  MIN_LENGTH,
  MIN_LOWERCASE,
  MIN_NUMBERS,
  MIN_SPECIAL_CHARACTERS,
  MIN_UPPERCASE,
  hasLowerCase,
  hasNumbers,
  hasSpecialCharacters,
  hasUpperCase,
} from "../../../helpers/auth/passwordSchema";
import { useTranslation } from "react-i18next";

export interface PasswordRuleProps {
  valid?: boolean;
  children: ReactNode;
}

const PasswordRule = ({ valid = false, children }: PasswordRuleProps) => {
  return (
    <li className={valid ? "text-green-600" : "text-red-600"}>
      {valid ? <Check /> : <Clear />}
      {children}
    </li>
  );
};

export interface PasswordRulesProps {
  password?: string;
  confirmPassword?: string;
}

const PasswordRules = ({ password, confirmPassword }: PasswordRulesProps) => {
  const { t } = useTranslation(["users", "errors"]);
  return (
    <ul>
      <PasswordRule valid={password === confirmPassword}>
        {t("errors:passwordsMustMatch")}
      </PasswordRule>
      <PasswordRule valid={(password?.length ?? 0) >= MIN_LENGTH}>
        {t("users:atLeast")} {MIN_LENGTH} {t("users:characters")}
      </PasswordRule>
      <PasswordRule valid={!!password && hasLowerCase(password)}>
        {t("users:atLeast")} {MIN_LOWERCASE} {t("users:lowercaseLetters")}
      </PasswordRule>
      <PasswordRule valid={!!password && hasUpperCase(password)}>
        {t("users:atLeast")} {MIN_UPPERCASE} {t("users:uppercaseLetters")}
      </PasswordRule>
      <PasswordRule valid={!!password && hasNumbers(password)}>
        {t("users:atLeast")} {MIN_NUMBERS} {t("users:numbers")}
      </PasswordRule>
      <PasswordRule valid={!!password && hasSpecialCharacters(password)}>
        {t("users:atLeast")} {MIN_SPECIAL_CHARACTERS}{" "}
        {t("users:specialCharacters")}
      </PasswordRule>
    </ul>
  );
};

export default PasswordRules;
